// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { loadContactRequestView } from '../../redux/reducers/contactrequests';

import ContactRequestDetailModal from '../../components/ContactRequests/ContactRequestDetailModal';

import Loader from '../../components/Loader/Loader';

import { colors } from '../../shared/styles';

const ContactRequestViewWrapper = styled.div`
    display: flex;
    position: relative;

    .list {
        background: ${colors.white};
        flex-grow: 1;
    }

    .list-wrapper {
        background: ${colors.white};
        height: calc(100vh - 152px);
        overflow: hidden;
    }

    .filter {
        flex: 0 0 300px;
        background: ${colors.grey.default};
        color: ${colors.white};

        .btn {
            display: block;
            background: ${colors.orange.default};
            color: ${colors.white};
            border-radius: 4px;
            text-align: center;
            text-decoration: none;
            padding: 12px 0;
            width: 100%;
            border: 0;
            font-size: 16px;
        }

        .search-section {
            padding: 20px;
            border-bottom: solid 1px ${colors.grey.light};
        }

        h2 {
            margin: 0;
            padding: 20px 30px 20px 30px;
            font-weight: lighter;
            border-bottom: solid 1px ${colors.grey.light};
        }
    }

    .stats {
        display: block;
        text-align: center;
        font-size: 14px;
        font-stretch: normal;
        color: ${colors.darkBlue.default};
    }
`;

class ContactRequestView extends Component {
    onContactRequest: Function;
    onHideContactRequest: Function;
    state: Object;

    constructor(props) {
        super(props);

        this.state = {
            viewingContactRequestId: null,
        };

        this.onContactRequest = this.onContactRequest.bind(this);
        this.onHideContactRequest = this.onHideContactRequest.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(
            loadContactRequestView(this.props.match.params.contactRequestId)
        );

        this.setState({
            viewingContactRequestId: this.props.match.params.contactRequestId,
        });
    }

    onContactRequest(contactRequestId) {
        this.setState({
            viewingContactRequestId: contactRequestId,
        });
    }

    onHideContactRequest() {
        this.setState({
            viewingContactRequestId: null,
        });
    }

    render() {
        const { contactRequest, isFetching } = this.props;

        const { viewingContactRequestId } = this.state;

        if (isFetching || !contactRequest) {
            return (
                <Loader message="Loading contact requests, please wait..." />
            );
        }

        return (
            <ContactRequestViewWrapper>
                <ContactRequestDetailModal
                    contactRequest={contactRequest}
                    isOpen={viewingContactRequestId !== null}
                    onCancel={this.onHideContactRequest}
                    redirectToList={true}
                />
            </ContactRequestViewWrapper>
        );
    }
}

const mapStateToProps = state => {
    const view = state.contactrequests.view;
    return {
        errorFetching: view.error,
        isFetching: view.fetching,
        contactRequest: state.contactrequests.view.contactRequest,
    };
};

export default connect(mapStateToProps)(ContactRequestView);



// WEBPACK FOOTER //
// ./src/containers/ContactRequests/ContactRequestView.js